require('./bootstrap')
require('./app')
require('./index-page')
require('./products')
import _ from "lodash";
import Services from "./classes/Services";
import {PageHandler} from "./classes/Handler";
import RegistererProviderCallback from "./classes/Providers/RegistererProviderCallback";
import RegistererOnLoadCallback from "./classes/Providers/RegistererOnLoadCallback";
import Configurations from "./plugins/config.datatable";
import initRTL from "./plugins/datatable.rtl";
import Notifier from "../../global/js/Utils/Notifier";
import {delay} from "../../global/js/Utils/Delay";
// import {initialReCaptcha} from "./classes/Pages/Auth";
var App = {
    start: function () {
        this.initProviders();
        Services.start();
    },

    initProviders: function () {
        RegistererProviderCallback.booting(function () {
            customFunctions.init();
            actionHandler.init();
            RegistererOnLoadCallback.booting(Services.initPageLoader);
            RegistererOnLoadCallback.booting(actionHandler.onReady);
            RegistererOnLoadCallback.booting(function () {
                PageHandler().fire();
            });
            RegistererOnLoadCallback.booting(function () {
                if (typeof $.fn.DataTable !== 'undefined') {
                    initRTL()
                    Configurations.init();
                }
            });
            RegistererOnLoadCallback.booted(function () {
                preloader.then(() => {
                    delay().time(500).handler(function () {
                        // showing sweetalert`s
                        Notifier.sweetAlert()

                        // showing toaster`s
                        Notifier.toaster()

                        // run external Jobs
                        if (_.isArray(ProviderJobs)) {
                            ProviderJobs.map((callback) => {
                                if (_.isFunction(callback)) {
                                    callback()
                                }
                            })
                        }
                    }).fire()
                });
            });
        });
    }
}

window.customFunctions = {
    init: function () {
        this.id();
        this.inputFilter();
        this.serializeObject();
        this.addProperty();
        this.preventDoubleSubmission();
        this.preventEnterKeySubmission();
        this.disableSubmitButton();
        this.enableSubmitButton();
    },

    serializeObject: function () {
        $.fn.serializeObject = function () {
            const o = {};
            const a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name] !== undefined) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        }
    },

    addProperty: function () {
        $.fn.addProperty = function (properties) {
            const $object = {...this}[0];
            Object.assign($object, properties);
            return $object;
        }
    },

    id: function () {
        $.fn.id = function () {
            return this.attr('id');
        }
    },

    preventDoubleSubmission: function () {
        $.fn.preventDoubleSubmission = function (exception = false) {
            const $form = this;
            $form.on('submit', function (e) {
                if ($form.data('submitted') === true) {
                    e.preventDefault();
                    throw new Error('The action taken is unauthorized.');
                } else {
                    $form.attr('data-submitted', true);
                }
            });
            return this;
        }
    },

    preventEnterKeySubmission: function () {
        $.fn.preventEnterKeySubmission = function () {
            const $form = $(this);
            $form.on('keydown', function (e) {
                if (e.keyCode === 13 || e.key === 'Enter') {
                    e.preventDefault();
                    throw new Error('The action taken is unauthorized.');
                }
            });
            return this;
        }
    },

    disableSubmitButton: function () {
        $.fn.disableSubmitButton = function () {
            const $form = this;
            $form.find('button[type="submit"]').prop('disabled', true);
            $(document).find('button[form=' + $form.id() + ']').prop('disabled', true);
        }
    },

    enableSubmitButton: function () {
        $.fn.enableSubmitButton = function () {
            const $form = this;
            $form.find('button[type="submit"]').prop('disabled', false);
            $(document).find('button[form=' + $form.id() + ']').prop('disabled', false);
        }
    },

    inputFilter: function () {
        $.fn.extend({
            inputFilter: function (option) {
                const defaults = {
                    regex: ".",
                    negkey: false, // use "-" if you want to allow minus sign at the beginning of the string
                    live: false,
                    events: 'keypress paste',
                };
                let options = $.extend(defaults, option);

                function filter_input_function(event) {

                    let regex;
                    let string;
                    const input = (event.input) ? event.input : $(this);
                    if (event.ctrlKey || event.altKey) return;
                    if (event.type === 'keypress') {
                        const key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
                        // 8 = backspace, 9 = tab, 13 = enter, 35 = end, 36 = home, 37 = left, 39 = right, 46 = delete
                        if (key === 8 || key === 9 || key === 13 || key === 35 || key === 36 || key === 37 || key === 39 || key === 46) {

                            // if charCode = key & keyCode = 0
                            // 35 = #, 36 = $, 37 = %, 39 = ', 46 = .

                            if (event.charCode === 0 && event.keyCode === key) {
                                return true;
                            }
                        }
                        string = String.fromCharCode(key);
                        // if they pressed the defined negative key
                        if (options.negkey && string === options.negkey) {
                            // if there is already one at the beginning, remove it
                            if (input.val().substring(0, 1) === string) {
                                input.val(input.val().substring(1, input.val().length)).change();
                            } else {
                                // it isn't there so add it to the beginning of the string
                                input.val(string + input.val()).change();
                            }
                            return false;
                        }
                        regex = new RegExp(options.regex);
                    } else if (event.type === 'paste') {
                        input.data('value_before_paste', event.target.value);
                        setTimeout(function () {
                            filter_input_function({type: 'after_paste', input: input});
                        }, 1);
                        return true;
                    } else if (event.type === 'after_paste') {
                        string = input.val();
                        regex = new RegExp('^(' + options.regex + ')+$');
                    } else {
                        return false;
                    }

                    if (regex.test(string)) {
                        return true;
                    } else if (typeof (options.feedback) == 'function') {
                        options.feedback.call(this, string);
                    }
                    if (event.type === 'after_paste') input.val(input.data('value_before_paste'));
                    return false;
                }

                const jquery_version = $.fn.jquery.split('.');
                if (options.live) {
                    if (parseInt(jquery_version[0]) >= 1 && parseInt(jquery_version[1]) >= 7) {
                        $(this).on(options.events, filter_input_function);
                    } else {
                        $(this).live(options.events, filter_input_function);
                    }
                } else {
                    return this.each(function () {
                        const input = $(this);
                        if (parseInt(jquery_version[0]) >= 1 && parseInt(jquery_version[1]) >= 7) {
                            input.off(options.events).on(options.events, filter_input_function);
                        } else {
                            input.unbind(options.events).bind(options.events, filter_input_function);
                        }
                    });
                }

            }
        });
    }
}
window.actionHandler = {
    init: function () {
        this.clickEvent.togglePassword();
    },

    onReady: function () {
        Services.initTooltips()
    },

    clickEvent: {
        togglePassword: function () {
            const $elem_class = 'toggle-password';
            const $elem = $(document).find('.'.concat($elem_class));
            $elem.on('click', function () {
                const $this = $(this);
                const $parent_elem = $(this).closest('div');
                const $password_input = $parent_elem.find('input');
                if ($password_input.attr('type') === 'password') {
                    $password_input.attr('type', 'text');
                    $this.removeClass('fa-eye-slash').addClass('fa-eye');
                    return;
                }
                $password_input.attr('type', 'password');
                $this.removeClass('fa-eye').addClass('fa-eye-slash');
            });
        },
    },
}

try {
    App.start();
} catch (e) {
    Services.captureError(e);
}